import React from "react";
import {
  TextAndImageRowsBase,
  Feature,
  FeatureImage,
  FeatureText,
} from "./text-and-image-rows.styled";
import { TextAndImageRowsSliceFragment } from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { GatsbyImage } from "gatsby-plugin-image";

export type ITextAndImageRowsProps = Slice<
  SharedSliceType.text_and_image_rows,
  TextAndImageRowsSliceFragment["primary"],
  TextAndImageRowsSliceFragment["items"][number]
> & { type: SharedSliceType.text_and_image_rows };

const TextAndImageRows = ({
  slice,
  context,
}: SliceComponentProps<ITextAndImageRowsProps, IPageContext>) => {
  const features = slice.items;

  return (
    (slice && (
      <TextAndImageRowsBase>
        {features.length > 0 && (
          <>
            {features?.map(
              (feature, index) =>
                feature && (
                  <Feature key={index}>
                    <FeatureText>
                      {feature.heading && (
                        <PrismicRichText
                          field={feature.heading?.richText}
                          components={htmlSerializer}
                        />
                      )}
                      {feature.description && (
                        <PrismicRichText
                          field={feature.description?.richText}
                          components={htmlSerializer}
                        />
                      )}
                    </FeatureText>
                    {feature.image?.gatsbyImageData && (
                      <FeatureImage>
                        {feature.image && (
                          <GatsbyImage
                            className="object-contain"
                            key={index}
                            image={feature.image.gatsbyImageData}
                            alt={feature.image.alt || "Xometry Image"}
                          />
                        )}
                      </FeatureImage>
                    )}
                  </Feature>
                )
            )}
          </>
        )}
      </TextAndImageRowsBase>
    )) || <></>
  );
};

export default TextAndImageRows;
